import './BlogDetail.css';
import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getBlogBySlug } from "../../../../services/blogsService";
import BlogHero from '../hero/BlogHero';

export default function BlogDetail() {
  const { blogType,slug } = useParams(); // ✅ correct place
  const [blog, setBlog] = useState([]); // ✅ state

  const getBlog = async () => {
    try {

      const response = await getBlogBySlug(blogType,slug);
      
      // adjust based on your API response shape
      setBlog(response?.items || response || []);

    } catch (error) {
      console.error("Error fetching blogs:", error);
    }
  };
   useEffect(() => {
    if (blogType && slug) {
      getBlog(); // ✅ call API
    }
  }, [blogType]);
  
  return (<>
        <BlogHero title = {blog.title} blogType={blog.blogType} coverImage={blog.coverImageUrl}/>
    
     <main class="blog-layout">
      <article className="blog-main glass-card">

  {blog.coverImageUrl && (
    <img
      src={blog.coverImageUrl}
      alt={blog.title}
      className="cover-image"
    />
  )}

  {/* ✅ Proper HTML */}
  <div
    className="blog-content"
    dangerouslySetInnerHTML={{ __html: blog.content }}
  />

  <div className="image-grid">
    {blog.coverImageUrl && (
      <img src={blog.coverImageUrl} alt={blog.title} />
    )}
    {blog.featuredImageUrl && (
      <img src={blog.featuredImageUrl} alt={blog.title} />
    )}
  </div>

</article>

      <aside class="sidebar">
        {/* <div class="related-posts glass-card">
          <h3>Popular Posts</h3>
          <div class="post">
            <img
              src="https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=400&q=80"
              alt="Car Blog"
            />
            <a href="#">Top 5 Performance Cars of 2025</a>
          </div>
          <div class="post">
            <img
              src="https://images.unsplash.com/photo-1601933470928-cfb43c4437b3?auto=format&fit=crop&w=400&q=80"
              alt="Bike Blog"
            />
            <a href="#">Best Touring Bikes for Long Rides</a>
          </div>
          <div class="post">
            <img
              src="https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=400&q=80"
              alt="Garage Blog"
            />
            <a href="#">How to Choose the Right Garage</a>
          </div>
        </div> */}

        {/* <div className="subscribe-box glass-card">
          <h3>Join Our Riders Club</h3>
          <p>Stay updated with latest bike & car stories.</p>
          <input type="email" placeholder="Enter your email" />
          <button>Subscribe</button>
        </div> */}
      </aside>
    </main>
</>
  )
}